// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkArrowRight: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 5 9" width={width} height={height}>
            <path
                fill="currentColor"
                d="M4.78 4.12a.39.39 0 0 1 0 .513L1.443 8.27a.315.315 0 0 1-.47 0 .39.39 0 0 1 0-.513l3.099-3.38L.973.995a.39.39 0 0 1 0-.514.315.315 0 0 1 .471 0z"
            />
        </svg>
    );
};

export default React.memo(LinkArrowRight);
